import { Button } from '@/components/ui/button';
import { useCreateEvent } from '@/features/events/hooks/useCreateEvent';
import { EventType } from '@/features/events/types/EventType';
import { LoadingOverlay } from '@/features/shared/components/Loaders';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReportCard } from '../components/ReportCard';
import { useGetDocuments } from '../hooks/useGetDocuments';

// TODO [TM]: mostra la card solo dopo che ilcarcimetno è completato (01/01/1970)
const Reports = () => {
  const { data: documents, isLoading, error } = useGetDocuments();
  const navigate = useNavigate();
  const { sendEvent } = useCreateEvent()

  useEffect(() => {
    void sendEvent({
      event: EventType.PAGE_VIEW,
      sub_category: "reports_page",
    })
  }, [])

  const onUploadReportClick = async () => {
    navigate('upload?type=ocr')
    
    await sendEvent({
      event: EventType.BUTTON_CLICK,
      sub_category: "action_button",
      event_metadata: { action: "upload_new_document" },
    })
  }

  const onReportClick = async (id: string) => {
    navigate(`document?id=${id}`)
    await sendEvent({
      event: EventType.CLICK,
      sub_category: "on_report_card_click",
      event_metadata: { document_id: id },
    })
  }

  if (isLoading) {
    return (
      <div className="relative w-full h-full">
        <LoadingOverlay />
      </div>
    )
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (!documents) {
    return <div>Errore, documenti non trovati</div>;
  }

  return (
    <div className='w-full h-screen flex flex-col overflow-hidden'>
      <div className='flex-1 overflow-y-auto scrollbar-hide'>
        <div className='space-y-2.5 pb-5'>
          {documents.length === 0 ? (
            <div>
              In quest'area puoi caricare i referti di laboratorio di analisi del
              sangue per condividere con la tua Medical Equipe i tuoi valori del
              sangue recenti. Per trarre il massimo vantaggio dalla condivisione dei
              tuoi referti {' '}
              <span
                className='font-bold underline text-primary cursor-pointer'
                onClick={() => {
                  window.open('https://www.holifya.com/', '_blank');
                }}
              >
                acquista un percorso Holifya o un consulto con il medico
              </span>{' '}
              per confrontarti.
            </div>
          ) : (
            [...documents]
              .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
              .map((document, index) => (
                <ReportCard
                  isReadable={document.is_readable}
                  key={index}
                  action={() => onReportClick(document.id)}
                  date={document.createdAt}
                  labName={document.labName}
                  numberOfMarkers={document.numberOfParameters}
                />
              ))
          )}
        </div>
      </div>
      <div className='py-5 bg-white border-t flex-shrink-0'>
        <Button
          size={'form'}
          className='w-full'
          onClick={onUploadReportClick}
        >
          Carica nuovo referto
        </Button>
      </div>
    </div>
  );
};

export default Reports;
